import { Box, Button, Card, CardContent, Chip, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, IconButton, CircularProgress } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React, { useEffect, useState } from 'react'
import '../styles/invoiceView.scss';
import InvoiceViewPage from './InvoiceViewPage'
import { globalGetService } from '../../../utils/globalApiServices';
import { getInvoiceApi, getSummaryInvoiceDetailApi, getInvoiceStatusTimelineApi, getInvoiceQbSyncHistoryApi, getLinkedInvoiceApi, getOffsetListApi, getCreditNoteOffsetAdjustmentApi, getPartialPaymentApi, getInvoiceApprovalDetailsApi, getMultiApprovalDetailsApi } from '../apiService';
import { checkApiStatus, twoDecimalfn, getGlobalCookie } from '../../../utils';
import { useNavigate, useParams, useLocation } from 'react-router';
import { ChangeInvoiceStatus, ChangeSummaryInvStatus, InvoiceActionHeader } from '../components';
import fileUpload, { getApiResponse } from '../../../utils/fileUpload';
import { useDispatch, useSelector } from 'react-redux';
import { NoRecordFound, PageLoader, STableLoader, titanAviInstance, gaTelesisInstance, hanwahaInstance, regionalOneInstance } from '../../../shared_elements';
import { displayDateFormatShort, displayDateFormatTime } from '../../../constants';
import moment from 'moment';
import NumericLabel from 'react-pretty-numbers';
import FileUploadLayout from '../../../shared_elements/components/FileUploadLayout';
import AddPenaltyInv from '../components/AddPenaltyInv';
import AddLinkedInv from '../components/AddLinkedInv';
import { setUploadFiles } from '../../../shared_elements/actions';
import { enqueueSnackbar } from 'notistack';
import { trackActivity } from '../../../utils/mixpanel';
import PartialPaymentsModal from '../components/PartialPaymentsModal';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import LessMoreforInvoice from '../../../shared_elements/components/LessMoreforInvoice';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PartialPaymentItemModal from '../components/PartialPaymentItemModal';
import SummaryPartialPaymentItemModal from '../components/SummaryPartialPaymentItemModal';
import SummaryPartialPaymentsListModal from '../components/SummaryPartialPaymentsListModal';
import OffsetItemsModal from '../components/OffsetItemsModal';
import UtilsAttachments from '../components/UtilsAttachments';
import RevertInvoiceStatus from '../components/RevertInvoiceStatus';
import InvoiceApprovalFlow from '../components/InvoiceApprovalFlow';
import MultiApprovalFlow, { getOverallStatus } from '../components/MultiApprovalFlow';
import InvoiceTimelineCard from '../components/InvoiceTimelineCard';
import QbSyncTimelineCard from '../components/QbSyncTimelineCard';
import NoWorkingGroupModal from '../../utilizations/components/NoWorkingGroupModal';
import UploadAttachmentsModal from '../components/InvUploadAttachmentsModal';
import { Restore as RestoreIcon, Edit as EditIcon } from '@mui/icons-material';
import { PermissionWrapper } from '../../../wrappers';
import InternalRemarks from '../components/InternalRemarks';
import InternalRemarksHistory from '../components/InternalRemarksHistory';

const STATUS_COLORS = { 1: '#98BAF0', 2: '#E3D38D', 3: '#B8FFA4', 4: '#f94e35', 5: '#85CA85' };

const statusBarSx = (statusValue) => ({
    borderLeft: `5px solid ${STATUS_COLORS[statusValue] || '#ccc'}`,
});

const InvoiceDetailPage = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const isSummaryInvoice = location.pathname.startsWith('/summary-invoices/');
    const [invoice, setInvoice] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [invoiceNotFound, setInvoiceNotFound] = useState(false);
    const [invoiceStatus, setInvoiceStatus] = useState({ modal: false, data: {} })
    const [revertStatusInv, setRevertStatusInv] = useState({ modal: false, data: null })
    const [linkedInvoice, setLinkedInvoice] = useState({ modal: false, data: null })
    const [penaltyInvoice, setPenaltyInvoice] = useState({ modal: false, data: null })
    const [uploadFileProgressData, setUploadFileProgressData] = useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({})
    const uploadedFileData = getApiResponse("Invoices", slug);
    const [uploadAttachments, setUploadAttachments] = useState({ modal: false, data: null });
    const { fileUploadDetails, uploadFiles } = useSelector((state) => state.leases);
    const [partialPaymentInfo, setPartialPaymentInfo] = useState({ list: [], pagination: {} });
    const [standardOffsetInfo, setStandardOffsetInfo] = useState({});
    const [creditNoteOffsetInfo, setCreditNoteOffsetInfo] = useState({});
    const [linkedInvoiceInfo, setlinkedInvoiceInfo] = useState({ list: [], pagination: {} });
    const [skeletonLoader, setSkeletonLoader] = useState(true);
    const [partialPaymentModal, setpartialPaymentModal] = useState({ modal: false, data: null })
    const [partialPaymentItemModal, setpartialPaymentItemModal] = useState({ modal: false, data: null })
    const [summaryPartialPaymentItemModal, setSummaryPartialPaymentItemModal] = useState({ modal: false, data: null })
    const [summaryPartialPaymentsListModal, setSummaryPartialPaymentsListModal] = useState(false)
    const [offsetListModal, setoffsetListModal] = useState({ modal: false, data: null })
    const from = sessionStorage.getItem("invoiceViewFrom");
    const [statusTimelineInfo, setStatusTimelineInfo] = useState([])
    const [approvalInfo, setApprovalInfo] = useState(null)
    const [multiApprovalInfo, setMultiApprovalInfo] = useState(null)
    const [multiApprovalLoading, setMultiApprovalLoading] = useState(false)
    const [timelineLoader, setTimelineLoader] = useState(true)
    const [qbSyncHistory, setQbSyncHistory] = useState([])
    const [qbSyncHistoryLoader, setQbSyncHistoryLoader] = useState(false)
    const [qbSyncTimelineOpen, setQbSyncTimelineOpen] = useState(false)
    const [statusTimelineOpen, setStatusTimelineOpen] = useState(false)
    const [noWorkingGroupModal, setNoWorkingGroupModal] = useState({ open: false, isMemberMismatch: false, title: 'Reserve Invoice' })
    const [internalRemarksEdit, setInternalRemarksEdit] = useState({ modal: false, data: null, mode: '' });
    const [internalRemarksHistory, setInternalRemarksHistory] = useState({ modal: false, data: null });
    const isMultiApproval = titanAviInstance && (invoice?.invoice_type?.value === 1 || (invoice?.parent_id && invoice?.parent_invoice_type?.value === 1))
    const approvalInfoForHeader = isMultiApproval ? { groupDecisions: [{ decision: { status: getOverallStatus(multiApprovalInfo?.controlStages) === 'approved' ? 2 : null } }] } : approvalInfo
    const offsetListInfo = invoice?.invoice_type?.value === 5 ? creditNoteOffsetInfo : standardOffsetInfo;

    useEffect(() => {
        (uploadFiles?.modal && params?.slug === uploadFiles?.slug) && handleUpload(uploadFiles?.slug, 'created')
        getInvoice('skeletonLoader');
        getLinkedInvoices('skeletonLoader')
        getPartialPaymentList('skeletonLoader')
        getOffsetList('skeletonLoader')
        getStatusTimeline();
        trackActivity('Page Viewed', { page_title: 'View Invoice' })
        setUploadFileProgressData({ uploadedFileData });
    }, [params?.slug]);

    useEffect(() => {
        if (hanwahaInstance && invoice?.id && !isSummaryInvoice) getQbSyncHistory(invoice.id);
        else setQbSyncHistory([]);
    }, [invoice?.id, isSummaryInvoice]);

    useEffect(() => {
        if (!invoice?.slug) return;
        // Old single-approval flow is left as-is (always fetched). Titan is only fetched when the invoice actually has approval enabled.
        if (isMultiApproval) {
            if (invoice?.is_invoice_approval) getMultiApprovalDetails();
        } else {
            getApprovalDetails();
        }
    }, [invoice?.slug, invoice?.invoice_type?.value, invoice?.parent_id, invoice?.child_invoice_type, invoice?.parent_invoice_type, invoice?.is_invoice_approval]);

    const getInvoice = (loaderType) => {
        setLoading(true);
        if (loaderType === 'skeletonLoader') setSkeletonLoader(true);
        const apiUrl = isSummaryInvoice ? getSummaryInvoiceDetailApi(params) : getInvoiceApi(params);
        globalGetService(apiUrl)
            .then(response => {
                setSkeletonLoader(false);
                if (response?.data?.status === "ERROR" && response?.data?.statusCode === 400) {
                    setInvoiceNotFound(true);
                    setLoading(false);
                    return;
                }

                if (checkApiStatus(response)) {
                    const data = isSummaryInvoice
                        ? { ...response?.data?.data?.summary, invoices: response?.data?.data?.invoices || [] }
                        : response?.data?.data;
                    setInvoice(data);
                }
                setLoading(false);
            })
            .catch(() => {
                setInvoiceNotFound(true);
                setLoading(false);
            });
    };

    const getLinkedInvoices = (loaderType) => {
        if (loaderType === 'skeletonLoader') setSkeletonLoader(true);
        globalGetService(getLinkedInvoiceApi(params), {}).then(response => {
            setSkeletonLoader(false);
            if (checkApiStatus(response)) {
                setlinkedInvoiceInfo(response?.data?.data)
            }
        });
    }

    const getPartialPaymentList = (loaderType) => {
        if (loaderType === 'skeletonLoader') setSkeletonLoader(true);
        globalGetService(getPartialPaymentApi(params), {}).then(response => {
            setSkeletonLoader(false);
            if (checkApiStatus(response)) {
                setPartialPaymentInfo(response?.data?.data)
            }
        });
    }


    const getOffsetList = (loaderType) => {
        if (loaderType === 'skeletonLoader') setSkeletonLoader(true);
        globalGetService(getOffsetListApi(params), {}).then(response => {
            setSkeletonLoader(false);
            if (checkApiStatus(response)) {
                setStandardOffsetInfo(response?.data?.data)
            }
        });
        globalGetService(getCreditNoteOffsetAdjustmentApi(params), {}).then(response => {
            setSkeletonLoader(false);
            if (checkApiStatus(response)) {
                setCreditNoteOffsetInfo(response?.data?.data)
            }
        });
    }

    const getNoWorkingGroupModalTitle = (invoiceType) => {
        if (invoiceType?.label === 'Credit Note') return 'Credit Invoice'
        if (invoiceType?.label === 'Debit Note') return 'Debit Invoice'
        return invoiceType?.label || 'Reserve Invoice'
    }

    const onGenerateLinkedInvoice = (invoiceType) => {
        if (invoiceType?.value === 3) {
            const subTotal = (invoice?.invoice_items || []).reduce((sum, item) => sum + (Number(item?.sub_total) || 0), 0);
            if (!subTotal) {
                enqueueSnackbar('Penalty invoice not applicable when the invoice amount is zero.', { variant: 'error', preventDuplicate: true, anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                trackActivity('Item Clicked', { page_title: 'View Invoice', page_type: 'Add Penalty Invoice', error_msg: 'Zero invoice amount' });
                return;
            }
        }
        if (isMultiApproval && invoice?.invoice_type?.value === 1 && invoice?.is_invoice_approval && multiApprovalInfo) {
            const currentUserId = JSON.parse(getGlobalCookie('lessorAccess'))?.user?.id
            const firstControlStage = multiApprovalInfo?.controlStages?.find(stage => stage?.control_stage === 1)
            const isFinanceWgMember = firstControlStage?.members?.some(m => m?.member_info?.user_id === currentUserId)
            const modalTitle = getNoWorkingGroupModalTitle(invoiceType)
            if (!firstControlStage?.members?.length) {
                setNoWorkingGroupModal({ open: true, isMemberMismatch: false, title: modalTitle })
                return
            }
            if (!isFinanceWgMember) {
                setNoWorkingGroupModal({ open: true, isMemberMismatch: true, title: modalTitle })
                return
            }
        }
        let linkedItem = {
            parent_id: invoice.id,
            invoice_number: "",
            invoice_type: invoiceType,
            currency: invoice.currency,
            invoice_division: "",
            to: invoice.to,
            invoice_items: invoice.invoice_items.map(item => {

                return { ...item, excess_amount: 0, original_amount: twoDecimalfn(item?.linked_remaining_amount), total_for_debit: item?.sub_total, sub_total: 0, tax_rate: item?.tax_rate, tax_amount: 0, sub_reference_id: item?.sub_reference_id }
            }),
            bank: invoice.bank,
            amount: invoice.amount,
            date: null,
            due_date: null,
            date_validation: invoice.date,
            asset: invoice.asset,
            from: invoice.from,
            start_date: invoice.start_date,
            end_date: invoice.end_date,
            remarks: '',
            parent_invoice: invoice.invoice_type.label,
            parent_invoice_type: invoice.invoice_type.value,
            parent_invoice_slug: invoice?.slug,
            lease_slug: invoice?.lease_slug,
        }
        if (invoiceType.value !== 3) {
            setLinkedInvoice({ ...linkedInvoice, modal: true, data: linkedItem })
        } else {
            setPenaltyInvoice({ ...penaltyInvoice, modal: true, data: linkedItem })
        }
    }


    const onDeteAttchments = () => {
        getInvoice()
    }

    const getApprovalDetails = () => {
        const currentUserId = JSON.parse(getGlobalCookie('lessorAccess'))?.user?.id
        globalGetService(getInvoiceApprovalDetailsApi(params.slug)).then(response => {
            if (checkApiStatus(response)) {
                const data = response.data.data
                const members = data?.members || []
                const groupDecisions = data?.group_decisions || []
                const currentUserMember = members.find(
                    m => m.member_info?.user_id === currentUserId && m.status === 1
                )
                const currentUserMemberSlug = members.find(
                    m => m.member_info?.user_id === currentUserId
                )?.slug || null
                const anotherUserMemberSlug = members.find(
                    m => m.member_info?.user_id !== currentUserId
                )?.slug || null
                const userHasPermission = !!currentUserMember
                const userApprovalSlug = currentUserMember?.slug || null
                let statusCode = 1
                if (members.length > 0) {
                    const latestDecision = groupDecisions[0]?.decision
                    if (!latestDecision) statusCode = 2
                    else if (latestDecision.status === 3) statusCode = 4
                    else if (latestDecision.status === 2) statusCode = 3
                    else statusCode = 2
                }
                setApprovalInfo({ members, groupDecisions, statusCode, userHasPermission, userApprovalSlug, currentUserMemberSlug, anotherUserMemberSlug })
            }
        })
    }

    const getMultiApprovalDetails = () => {
        setMultiApprovalLoading(true)
        globalGetService(getMultiApprovalDetailsApi(params.slug)).then(response => {
            setMultiApprovalLoading(false)
            if (checkApiStatus(response)) {
                setMultiApprovalInfo({ controlStages: response.data.data?.control_stages || [] })
            }
        }).catch(() => setMultiApprovalLoading(false))
    }

    const getStatusTimeline = (loaderType) => {
        setTimelineLoader(true);
        const timelineQuery = isSummaryInvoice ? { is_summary_timeline: true } : {};
        globalGetService(getInvoiceStatusTimelineApi(params, timelineQuery)).then(response => {
            setTimelineLoader(false);
            if (checkApiStatus(response)) {
                setStatusTimelineInfo(response?.data?.data);
            }
        }).catch(() => setTimelineLoader(false));
    }

    const getQbSyncHistory = (invoiceId) => {
        setQbSyncHistoryLoader(true);
        globalGetService(getInvoiceQbSyncHistoryApi(invoiceId)).then(response => {
            setQbSyncHistoryLoader(false);
            if (checkApiStatus(response)) {
                setQbSyncHistory([...(response?.data?.data || [])].reverse());
            }
        }).catch(() => setQbSyncHistoryLoader(false));
    }

    const handleUpload = async (slug, mode) => {
        setSlug({ slug: slug })
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "invoices",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments, response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" }
                });
                getInvoice()
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", {
                    variant: "error",
                    anchorOrigin: { vertical: "top", horizontal: "right" }
                });
            }
        });
        dispatch(setUploadFiles({}));
        setSlug({})
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Invoice View Page`, page_type: page_type, })
    }

    return (
        <section className="active-asset-section">
            {invoiceNotFound ? (
                <Dialog open={true} fullWidth maxWidth="sm">
                    <DialogTitle>Invoice Not Found</DialogTitle>
                    <DialogContent dividers>
                        <Typography>
                            The invoice you are trying to access does not exist or has been removed.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            size='small'
                            onClick={() => { navigate('/invoices', { replace: true }); handleItemClicked('Back to Listing Button') }}
                        >
                            Back to Listing
                        </Button>
                    </DialogActions>
                </Dialog>
            ) :
                <div className="lease-details-section" style={{ height: `${window.innerHeight - 80}px` }} >
                    <div >
                        <InvoiceActionHeader
                            slug={slug?.slug}
                            uploadedFileData={uploadedFileData}
                            uploadFileProgressData={uploadFileProgressData}
                            viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                            onAddLinkedInvoice={onGenerateLinkedInvoice}
                            onChangeStatus={() => setInvoiceStatus({ modal: true, data: invoice })}
                            onRevertStatus={() => setRevertStatusInv({ modal: true, data: invoice })}
                            invoiceDetails={invoice}
                            getInvoice={getInvoice}
                            invoiceType={invoice?.invoice_type?.label}
                            offsetInvoice={invoice?.offset_invoice}
                            onToggleModal={() => setInvoiceStatus({ modal: false, data: {} })}
                            viewFile={() => setUploadAttachments({ modal: true, data: invoice })}
                            getResponseBack={() => getInvoice()}
                            getTimeLineResponseBack={() => getStatusTimeline()}
                            from={from}
                            type='InvoiceView'
                            fileUpload={handleUpload}
                            approvalInfo={approvalInfoForHeader}
                            isMultiApproval={isMultiApproval}
                        />
                    </div>
                    <div className="lease-details-content" style={{ padding: "0px", margin: "10px 0px 0px 0px" }}>
                        <Grid container spacing={1}>
                            <Grid size={{ md: 9, xs: 12 }}>
                                <InvoiceViewPage invoice={invoice} skeletonLoader={skeletonLoader} type={invoice?.invoice_type?.label} isMultiApproval={isMultiApproval} controlStages={multiApprovalInfo?.controlStages} multiApprovalLoading={multiApprovalLoading} handleItemClicked={handleItemClicked} isInvoiceApproval={invoice?.is_invoice_approval} approvalInfo={approvalInfoForHeader} getResponseBack={() => getInvoice()} />
                            </Grid>
                            <Grid size={{ md: 3, xs: 12 }} sx={{ maxHeight: `${window.innerHeight - 157}px`, overflowY: 'auto' }}>
                                {invoice?.is_invoice_approval && invoice?.invoice_type?.value !== 10 && invoice?.lease_slug && (
                                    isMultiApproval
                                        ? multiApprovalInfo && <Card className="invoice-card" sx={{ mb: 1.2 }}>
                                            <CardContent className="invoice-content">
                                                <Box className="remarks-box">
                                                    <MultiApprovalFlow invoiceSlug={params.slug} leaseSlug={invoice?.lease_slug} controlStages={multiApprovalInfo.controlStages} getApprovalDetails={getMultiApprovalDetails} invoiceStatus={invoice?.status} getInvoice={getInvoice} />
                                                </Box>
                                            </CardContent>
                                        </Card>
                                        : approvalInfo && <Card className="invoice-card" sx={{ mb: 1.2 }}>
                                            <CardContent className="invoice-content">
                                                <Box className="remarks-box">
                                                    <InvoiceApprovalFlow invoiceSlug={params.slug} leaseSlug={invoice?.lease_slug} approvalInfo={approvalInfo} getApprovalDetails={getApprovalDetails} invoiceStatus={invoice?.status} getInvoice={getInvoice} />
                                                </Box>
                                            </CardContent>
                                        </Card>
                                )}
                                {gaTelesisInstance ?
                                    <Card className="invoice-card" sx={{ mb: 1.2 }}>
                                        <CardContent className="invoice-content">
                                            <Box className="remarks-box">
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                                                    <Typography variant="body2" className="meta-label" sx={{ fontWeight: 600 }}> Internal Remarks </Typography>
                                                    <Box>
                                                        <Tooltip title="Revision History"><RestoreIcon className='revision-history' sx={{ cursor: 'pointer' }} fontSize='small' color='primary' onClick={() => { setInternalRemarksHistory({ modal: true, data: invoice }); handleItemClicked('RevisionHistoryIcon') }} /></Tooltip>
                                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
                                                            <Tooltip title="Edit" arrow>
                                                                <EditIcon fontSize='small' color='primary' sx={{ cursor: 'pointer' }} onClick={() => { setInternalRemarksEdit({ modal: true, data: invoice, mode: 'edit' }); handleItemClicked('Remarks EditIcon') }} />
                                                            </Tooltip>
                                                        </PermissionWrapper>
                                                    </Box>
                                                </Box>
                                                <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', color: '#000000a6', background: '#f5f5f5', borderRadius: '4px', padding: '6px 10px' }}>
                                                    <LessMoreforInvoice value={invoice?.internal_remarks || 'Enter Internal Remarks'} />
                                                </Typography>
                                                {invoice?.internal_remarks_last_updated?.changed_by ?
                                                    <Typography variant="caption" sx={{ color: '#64748b', display: 'block', mt: 0.5 }}>
                                                        {`Last updated by ${invoice.internal_remarks_last_updated.changed_by}${invoice.internal_remarks_last_updated?.changed_at ? ` on ${moment(invoice.internal_remarks_last_updated.changed_at).format(`${displayDateFormatTime}`)}` : ''}`}
                                                    </Typography> : null}
                                            </Box>
                                        </CardContent>
                                    </Card>
                                    : invoice?.remarks ?
                                        <Card className="invoice-card" sx={{ mb: 1.2 }}>
                                            <CardContent className="invoice-content">
                                                <Box className="remarks-box">
                                                    <Typography variant="body2" className="meta-label" sx={{ fontWeight: 600, mb: 0.5 }}>
                                                        Remarks
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', color: '#000000a6', background: '#f5f5f5', borderRadius: '4px', padding: '6px 10px' }}>
                                                        <LessMoreforInvoice value={invoice?.remarks} />
                                                    </Typography>
                                                </Box>
                                            </CardContent>
                                        </Card> : null}
                                <Card className="invoice-card" sx={{ mb: 1.2 }}>
                                    <CardContent className="invoice-content">
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }} onClick={() => { setStatusTimelineOpen(prev => !prev); handleItemClicked('Invoice Status Timeline Toggle') }}>
                                            <Typography variant="subtitle1" className="party-heading">
                                                Invoice Status Timeline
                                            </Typography>
                                            <Tooltip title={statusTimelineOpen ? 'Collapse' : 'Expand'} arrow>
                                                <IconButton size="small">
                                                    <KeyboardArrowDownIcon fontSize="small" color="primary" sx={{ transition: 'transform 0.2s', transform: statusTimelineOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                        <Collapse in={statusTimelineOpen} timeout="auto" unmountOnExit>
                                            <Box sx={{ maxHeight: "310px", overflow: "auto" }}>
                                                <InvoiceTimelineCard
                                                    statusTimelineInfo={statusTimelineInfo}
                                                    skeletonLoader={timelineLoader}
                                                    invoice={invoice}
                                                />
                                            </Box>
                                        </Collapse>
                                    </CardContent>
                                </Card>
                                {hanwahaInstance && !isSummaryInvoice && ((qbSyncHistoryLoader && invoice?.qb_last_sync_by) || (!qbSyncHistoryLoader && qbSyncHistory?.length > 0)) ?
                                    <Card className="invoice-card" sx={{ mb: 1.2 }}>
                                        <CardContent className="invoice-content">
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: qbSyncHistoryLoader ? 'default' : 'pointer' }} onClick={() => { if (qbSyncHistoryLoader) return; setQbSyncTimelineOpen(prev => !prev); handleItemClicked('QB Sync Timeline Toggle') }}>
                                                <Typography variant="subtitle1" className="party-heading">
                                                    QB Sync Timeline
                                                </Typography>
                                                {qbSyncHistoryLoader ? <CircularProgress size={18} sx={{ m: '5px' }} /> :
                                                    <Tooltip title={qbSyncTimelineOpen ? 'Collapse' : 'Expand'} arrow>
                                                        <IconButton size="small">
                                                            <KeyboardArrowDownIcon fontSize="small" color="primary" sx={{ transition: 'transform 0.2s', transform: qbSyncTimelineOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
                                                        </IconButton>
                                                    </Tooltip>}
                                            </Box>
                                            <Collapse in={qbSyncTimelineOpen} timeout="auto" unmountOnExit>
                                                <Box sx={{ maxHeight: "310px", overflow: "auto" }}>
                                                    <QbSyncTimelineCard syncHistory={qbSyncHistory} skeletonLoader={qbSyncHistoryLoader} currency={invoice?.currency?.code || invoice?.currency} />
                                                </Box>
                                            </Collapse>
                                        </CardContent>
                                    </Card> : null}
                                {isSummaryInvoice && invoice?.partial_payments?.length > 0 ? <Card className="invoice-card" sx={{ mb: 1.2 }}>
                                    <CardContent className="invoice-content">
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                                            <Typography variant="subtitle1" className="party-heading">
                                                Partial Payment List
                                            </Typography>
                                            <Tooltip title="View" arrow>
                                                <OpenInNewRoundedIcon fontSize="small" onClick={() => { setSummaryPartialPaymentsListModal(true); handleItemClicked('View Partial Payment List Icon - Summary') }} color="primary" sx={{ cursor: 'pointer' }} />
                                            </Tooltip>
                                        </div>
                                        <Box className="items-section">
                                            <TableContainer component={Paper} className="lease-detail-table">
                                                {skeletonLoader ? <STableLoader count={2} rowCount={2} /> :
                                                    <Table className='mui-table-format' stickyHeader>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell className="table-header">Payment Date</TableCell>
                                                                <TableCell align='center' className="table-header">Paid Amount</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {invoice.partial_payments.map((item, index) => (
                                                                <TableRow key={index} className="table-row">
                                                                    <Tooltip title="View Details" arrow>
                                                                        <TableCell className="table-cell" sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => { setSummaryPartialPaymentItemModal({ modal: true, data: item }); handleItemClicked('Partial Payment Row - Summary') }}>
                                                                            <Typography variant="caption" color="primary" sx={{ fontSize: '13px' }}>
                                                                                {item?.payment_date ? moment(item.payment_date).format(displayDateFormatShort) : '--'}
                                                                            </Typography>
                                                                        </TableCell>
                                                                    </Tooltip>
                                                                    <TableCell align='center' className="table-cell">
                                                                        <NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: invoice?.currency, precision: 2, commafy: true, justification: 'L' }}>{item?.amount || 0}</NumericLabel>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>}
                                            </TableContainer>
                                        </Box>
                                    </CardContent>
                                </Card> : null}
                                {!isSummaryInvoice && partialPaymentInfo?.list?.length > 0 ? <Card className="invoice-card" sx={{ mb: 1.2 }}>
                                    <CardContent className="invoice-content">
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                                            <Typography variant="subtitle1" className="party-heading">
                                                Partial Payment List
                                            </Typography>
                                            {partialPaymentInfo?.list?.length > 0 ? <Tooltip title="View" arrow>
                                                <OpenInNewRoundedIcon fontSize="small" onClick={() => { setpartialPaymentModal({ modal: true, data: partialPaymentInfo }); handleItemClicked('View Partial Payment List Icon') }} color="primary" sx={{ cursor: "pointer" }} />
                                            </Tooltip> : null}
                                        </div>
                                        <Box className="items-section" >
                                            <TableContainer component={Paper} className="lease-detail-table">
                                                {skeletonLoader ? <STableLoader count={2} rowCount={2} /> :
                                                    <Table className='mui-table-format' stickyHeader>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell className="table-header" >Payment Date</TableCell>
                                                                <TableCell align='center' className="table-header" >Paid Amount</TableCell>
                                                                {invoice?.offset_amount ? <TableCell className="table-header" >Offset Amount</TableCell> : null}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {partialPaymentInfo?.list?.length > 0 ? partialPaymentInfo?.list?.map((item, index) => {
                                                                return (
                                                                    <TableRow key={index} className="table-row">
                                                                        <Tooltip title={"View"} arrow><TableCell className="table-cell" onClick={() => { setpartialPaymentItemModal({ modal: true, data: item }); handleItemClicked('Partial Payment Row') }} sx={{ textDecoration: 'underline', cursor: 'pointer' }}><Typography variant="caption" color="primary" sx={{ fontSize: "13px" }} > {item?.payment_date ? moment(item.payment_date).format(displayDateFormatShort) : '--'} </Typography></TableCell></Tooltip>
                                                                        <TableCell align='center'><NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: item?.currency, precision: 2, commafy: true, justification: 'L' }}>{item?.paid_amount || 0.00}</NumericLabel></TableCell>
                                                                        {invoice?.offset_amount ? <TableCell align='center'><NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: item?.currency, precision: 2, commafy: true, justification: 'L' }}>{item?.offset_amount || 0.00}</NumericLabel></TableCell> : null}
                                                                    </TableRow>
                                                                );
                                                            }) : (
                                                                <NoRecordFound />
                                                            )}
                                                        </TableBody>
                                                    </Table>}
                                            </TableContainer>
                                        </Box>
                                    </CardContent>
                                </Card> : null}
                                {linkedInvoiceInfo?.list?.length > 0 && !invoice?.parent_id ? <Card className="invoice-card" sx={{ mb: 1.2 }}>
                                    <CardContent className="invoice-content">
                                        <Typography variant="subtitle1" className="party-heading">
                                            Linked Invoice List
                                        </Typography>
                                        <Box className="items-section" >
                                            <TableContainer component={Paper} className="lease-detail-table" >
                                                {skeletonLoader ? <STableLoader count={2} rowCount={2} /> :
                                                    <Table className='mui-table-format' stickyHeader>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell className="table-header" >Invoice Number</TableCell>
                                                                <TableCell sx={{ minWidth: "140px" }} align='center' className="table-header" >Amount</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {linkedInvoiceInfo?.list?.length > 0 ? linkedInvoiceInfo?.list?.map((item, index) => {
                                                                return (
                                                                    <TableRow key={index} className="table-row">
                                                                        <Tooltip title="View" arrow><TableCell className="table-cell" onClick={() => { window.open(`/invoices/view/${item?.slug}`, "_blank"); handleItemClicked('Linked Invoice Row') }} sx={{ textDecoration: "underline", cursor: "pointer", ...statusBarSx(item?.status?.value) }}><Typography variant="caption" color="primary" sx={{ fontSize: "13px" }} > {item?.invoice_number || '--'} </Typography>
                                                                            <div><Chip sx={{ fontSize: "10px", height: "18px" }} label={`${item?.invoice_type?.label || '--'} ${[5, 4].includes(item?.invoice_type?.value) ? 'Note' : ''}`} size="small" variant="outlined" /></div>
                                                                        </TableCell></Tooltip>
                                                                        <TableCell align='center' ><NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: item?.currency, precision: 2, commafy: true, justification: 'L' }}>{(regionalOneInstance && item?.invoice_type?.value === 5) ? (-(Math.abs(item?.total_amount || 0)) || 0.00) : (item?.total_amount || 0.00)}</NumericLabel></TableCell>
                                                                    </TableRow>
                                                                );
                                                            }) : (
                                                                <NoRecordFound />
                                                            )}
                                                        </TableBody>
                                                    </Table>}
                                            </TableContainer>
                                        </Box>
                                    </CardContent>
                                </Card> : null}

                                {offsetListInfo?.length > 0 ? <Card className="invoice-card">
                                    <CardContent className="invoice-content">
                                        <Typography variant="subtitle1" className="party-heading">
                                            {invoice?.invoice_type?.value === 5 ? 'Parent Invoice Offset' : 'Credit Note Offset'}
                                        </Typography>
                                        <Box className="items-section" >
                                            <TableContainer component={Paper} className="lease-detail-table" >
                                                {skeletonLoader ? <STableLoader count={2} rowCount={2} /> :
                                                    <Table className='mui-table-format' stickyHeader>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell className="table-header" >Invoice Number</TableCell>
                                                                <TableCell className="table-header" >Amount</TableCell>
                                                                <TableCell className="table-header" >Action</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {offsetListInfo?.length > 0 ? offsetListInfo?.map((item, index) => {
                                                                return (
                                                                    <TableRow key={index} className="table-row">
                                                                        <Tooltip title="View" arrow><TableCell className="table-cell" onClick={() => { window.open(`/invoices/view/${item?.slug}`, "_blank"); handleItemClicked('Credit Note Offset Row') }} sx={{ textDecoration: "underline", cursor: "pointer", ...statusBarSx(item?.status?.value) }}><Typography variant="caption" color="primary" sx={{ fontSize: "13px" }} > {item?.invoice_number || '--'} </Typography>
                                                                        </TableCell></Tooltip>
                                                                        <TableCell align='center' ><span style={{ fontSize: '12px' }}><NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: item?.currency?.code, precision: 2, commafy: true, justification: 'L' }}>{item?.amount?.applied || 0}</NumericLabel></span>/<NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: item?.currency?.code, precision: 2, commafy: true, justification: 'L' }}>{item?.amount?.total || 0}</NumericLabel></TableCell>
                                                                        <TableCell align='center'>
                                                                            <Tooltip title="View" arrow>
                                                                                <VisibilityIcon fontSize="small" onClick={() => { if (item?.amount?.applied !== 0) { setoffsetListModal({ modal: true, data: item }); handleItemClicked('ViewIcon') } }} color={item?.amount?.applied === 0 ? "disabled" : "primary"} sx={{ cursor: item?.amount?.applied === 0 ? "default" : "pointer" }} />
                                                                            </Tooltip>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            }) : (
                                                                <NoRecordFound />
                                                            )}
                                                            {offsetListInfo?.length > 0 && (
                                                                <TableRow >
                                                                    <TableCell sx={{ fontWeight: 'bold', fontSize: '13px' }}>Total</TableCell>
                                                                    <TableCell align='center' sx={{ fontWeight: 'bold' }}>
                                                                        <NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: invoice?.currency?.code, precision: 2, commafy: true, justification: 'L' }}>
                                                                            {offsetListInfo.reduce((sum, item) => sum + (item?.amount?.applied || 0), 0)}
                                                                        </NumericLabel>
                                                                    </TableCell>
                                                                    <TableCell />
                                                                </TableRow>
                                                            )}
                                                        </TableBody>
                                                    </Table>}
                                            </TableContainer>
                                        </Box>
                                    </CardContent>
                                </Card> : null}
                                {invoice?.utilization_attachments?.length > 0 ? (
                                    <Card className="invoice-card" sx={{ mb: 1.2 }}>
                                        <CardContent className="invoice-content">
                                            <Box className="remarks-box">
                                                <Typography variant="body2" className="meta-label" sx={{ fontWeight: 600, mb: 0.5 }}>
                                                    Utilization Report
                                                </Typography>
                                                <UtilsAttachments data={invoice?.utilization_attachments} handleItemClicked={handleItemClicked} />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                ) : null}
                            </Grid>
                        </Grid>
                    </div>
                </div>}
            {invoiceStatus.modal ?
                invoice?.is_summary_invoice ?
                    <ChangeSummaryInvStatus
                        invoiceStatus={invoiceStatus}
                        getInvoice={getInvoice}
                        invoiceType={invoice?.invoice_type?.label}
                        onToggleModal={() => setInvoiceStatus({ modal: false, data: {} })}
                        getLinkedInvoices={getLinkedInvoices}
                        getResponseBack={() => getStatusTimeline()}
                    />
                    :
                    <ChangeInvoiceStatus
                        invoiceStatus={invoiceStatus}
                        getInvoice={getInvoice}
                        invoiceType={invoice?.invoice_type?.label}
                        offsetInvoice={invoice?.offset_invoice}
                        onToggleModal={() => setInvoiceStatus({ modal: false, data: {} })}
                        getPartialPaymentList={getPartialPaymentList}
                        getOffsetList={getOffsetList}
                        getLinkedInvoices={getLinkedInvoices}
                        getResponseBack={() => getStatusTimeline()}
                    />
                : null
            }
            {revertStatusInv.modal ?
                <RevertInvoiceStatus
                    revertStatusInv={revertStatusInv}
                    onToggleModal={() => setRevertStatusInv({ modal: false, data: null })}
                    getResponseBack={() => { getInvoice(); getStatusTimeline(); getPartialPaymentList(); }}
                /> : null
            }
            {linkedInvoice.modal ?
                <AddLinkedInv
                    addEditInvoice={linkedInvoice}
                    onToggleModal={() => setLinkedInvoice({ modal: false, mode: '', data: null })}
                    invoice={invoice}
                    setInvoice={setInvoice}
                    from={from}
                /> : null
            }
            {penaltyInvoice.modal ?
                <AddPenaltyInv
                    addEditInvoice={penaltyInvoice}
                    onToggleModal={() => setPenaltyInvoice({ modal: false, mode: '', data: null })}
                    invoice={invoice}
                    leaseSlug={invoice?.lease_slug}
                    invoiceSlug={invoice?.slug}
                    setInvoice={setInvoice}
                /> : null
            }
            <NoWorkingGroupModal
                open={noWorkingGroupModal?.open}
                isMemberMismatch={noWorkingGroupModal?.isMemberMismatch}
                leaseSlug={invoice?.lease_slug}
                title={noWorkingGroupModal?.title}
                onClose={() => setNoWorkingGroupModal({ open: false, isMemberMismatch: false, title: 'Reserve Invoice' })}
            />
            {partialPaymentModal.modal ?
                <PartialPaymentsModal
                    partialPaymentModal={partialPaymentModal}
                    onToggleModal={() => setpartialPaymentModal({ modal: false, data: null })}
                /> : null
            }
            {partialPaymentItemModal.modal ?
                <PartialPaymentItemModal
                    partialPaymentItemModal={partialPaymentItemModal}
                    onToggleModal={() => setpartialPaymentItemModal({ modal: false, data: null })}
                /> : null
            }
            <SummaryPartialPaymentItemModal
                modal={summaryPartialPaymentItemModal.modal}
                data={summaryPartialPaymentItemModal.data}
                currency={invoice?.currency}
                onClose={() => setSummaryPartialPaymentItemModal({ modal: false, data: null })}
            />
            <SummaryPartialPaymentsListModal
                modal={summaryPartialPaymentsListModal}
                list={invoice?.partial_payments}
                currency={invoice?.currency}
                onClose={() => setSummaryPartialPaymentsListModal(false)}
            />
            {offsetListModal.modal ?
                <OffsetItemsModal
                    invoiceType={invoice?.invoice_type}
                    offsetListModal={offsetListModal}
                    onToggleModal={() => setoffsetListModal({ modal: false, data: null })}
                /> : null
            }
            {uploadAttachments.modal ? <UploadAttachmentsModal
                uploadAttachments={uploadAttachments}
                onToggleModal={() => setUploadAttachments({ modal: false, data: null })}
                invSlug={(slug) => setSlug({ slug: slug })}
                onAttachmentDeleted={onDeteAttchments}
                progressData={(data) => setUploadFileProgressData(data)}
                getResponseBack={() => getInvoice()}
            /> : null}
            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={() => setSlug({})}
            />

            {internalRemarksEdit.modal ?
                <InternalRemarks
                    remarksEdit={internalRemarksEdit}
                    getResponseBack={() => getInvoice()}
                    onToggleModal={() => setInternalRemarksEdit({ modal: false, data: null, mode: '' })}
                /> : null}

            {internalRemarksHistory.modal ?
                <InternalRemarksHistory
                    remarksHistory={internalRemarksHistory}
                    onToggleModal={() => setInternalRemarksHistory({ modal: false, data: null })}
                /> : null}

            {isLoading ? <PageLoader /> : null}
        </section>
    )
}

export default InvoiceDetailPage
